import {
  FieldErrors,
  UseFormRegister,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form';

import {
  isDefined,
  MaritalInformationFormT,
} from '@consumer-frontend/nc-utils';

import { NcAddressFields } from '../NcAddressForm';
import { NcInput } from '../NcInput';
import { NcRadioButton } from '../NcRadioButton';
import { NcRadioGroup } from '../NcRadioGroup';

export type NcMaritalInformationSpouseFormPropsT = {
  errors: FieldErrors<MaritalInformationFormT>;
  register: UseFormRegister<MaritalInformationFormT>;
  setValue: UseFormSetValue<MaritalInformationFormT>;
  watch: UseFormWatch<MaritalInformationFormT>;
};

export const NcMaritalInformationSpouseForm = ({
  errors,
  register,
  setValue,
  watch,
}: NcMaritalInformationSpouseFormPropsT) => {
  const selectedSameAddress = watch('spouse.sameAddress');

  const onSpouseCohabitationChange = (value: boolean) => {
    setValue('spouse.sameAddress', value, { shouldValidate: true });
  };

  return (
    <div className="spouse-fields">
      <div className="spouse-name">
        <NcInput
          {...register('spouse.firstName', {
            required: "Enter your spouse's first name.",
          })}
          errorMessage={errors.spouse?.firstName?.message}
          id="spouseFirstName"
          label={<span className="form-label">Spouse First Name</span>}
          type="text"
        />
        <NcInput
          {...register('spouse.lastName', {
            required: "Enter your spouse's last name.",
          })}
          errorMessage={errors.spouse?.lastName?.message}
          id="spouseLastName"
          label={<span className="form-label">Spouse Last Name</span>}
          type="text"
        />
      </div>

      <NcRadioGroup
        {...register('spouse.sameAddress', {
          validate: (value) => isDefined(value) || 'Select an option to continue.',
        })}
        className="cohabitation"
        controlId="spouse-address"
        errorMessage={errors.spouse?.sameAddress?.message}
        label="Does your spouse live at the same address?"
        value={isDefined(selectedSameAddress) ? String(selectedSameAddress) : undefined}
      >
        <NcRadioButton
          id="spouse-address--same"
          label="Yes, same address"
          checked={selectedSameAddress === true}
          name="spouse-address"
          onChange={() => onSpouseCohabitationChange(true)}
          value="true"
        />
        <NcRadioButton
          id="spouse-address--different"
          label="No, different address"
          checked={selectedSameAddress === false}
          name="spouse-address"
          onChange={() => onSpouseCohabitationChange(false)}
          value="false"
        />
      </NcRadioGroup>

      {selectedSameAddress === false && (
        <div className="nc-spouse-address-fields">
          {/* eslint-disable-next-line react/jsx-curly-brace-presence */}
          <h2 className="nc-spouse-address-title">{"Spouse's Address"}</h2>

          <NcAddressFields isForSpouse />
        </div>
      )}
    </div>
  );
};
